'use es6';

import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { View } from 'foundations-components/components/View';
import promotingMenuDropTarget from 'simple-menus-lib/components/dnd/decorators/promotingMenuDropTarget';
import { MENU_TREE_INDENTATION } from '../../../constants/menus';
import { jsx as _jsx } from "react/jsx-runtime";
const PromotingMenuDropTarget = /*#__PURE__*/forwardRef(({
  depth = 0,
  isOver,
  canDrop,
  connectDropTarget
}, ref) => {
  let dropTargetBorderColor;
  let dropTargetBorderWidth;
  let dropTargetBorderStyle;
  if (isOver) {
    dropTargetBorderColor = 'border-info-default';
    dropTargetBorderWidth = '200';
    dropTargetBorderStyle = 'solid';
  } else if (!canDrop) {
    dropTargetBorderColor = undefined;
    dropTargetBorderWidth = undefined;
    dropTargetBorderStyle = undefined;
  }
  return connectDropTarget( /*#__PURE__*/_jsx("div", {
    ref: ref,
    children: /*#__PURE__*/_jsx(View, {
      inlineSize: `${MENU_TREE_INDENTATION}px`,
      blockSize: "55px",
      position: "relative",
      insetBlockEnd: "35px",
      borderInlineStartWidth: dropTargetBorderWidth,
      borderInlineStartColor: dropTargetBorderColor,
      borderInlineStartStyle: dropTargetBorderStyle
    })
  }, depth));
});
PromotingMenuDropTarget.propTypes = {
  depth: PropTypes.number.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool,
  canDrop: PropTypes.bool
};
export default promotingMenuDropTarget()(PromotingMenuDropTarget);